import * as React from "react"
const RtukSevenAgeIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080" {...props}>
    <circle
      cx={540}
      cy={541}
      r={401.71}
      style={{
        fill: "currentColor",
        stroke: "#1d1d1b",
        strokeMiterlimit: 10,
        strokeWidth: "70.75px",
      }}
    />
    <path d="M578.39 323.93V365c0 2.11-18.09 31.59-20.81 36.78-57.5 109.88-96.7 230.91-111.63 354.49l-1.4 1.8H349.1c7.8-51.7 24.73-101.69 43.24-150.35 26.92-70.78 59.98-139.11 93.26-206.99H310.17c-.4 0-3.73-2.42-3.73-2.67v-72.53l1.6-1.6h270.34ZM707.43 435.93v63.47l1.6 1.6h61.85c.35 0 1.62 1.41 2.67 1.07V557l-1.6 1.6h-62.92l-1.6 1.6v62.93l-1.6 1.6h-52.26c-.35 0-1.62-1.41-2.67-1.07v-62.4c0-.35-1.41-1.62-1.07-2.67h-63.45l-1.6-1.6v-53.33c0-.19 2.48-2.67 2.67-2.67h61.85l1.6-1.6v-63.47h56.52Z" />
  </svg>
)
export default RtukSevenAgeIcon
